
import { useState } from 'react';

export default function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <nav className="fixed top-0 w-full z-50 bg-white/95 backdrop-blur-sm border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex items-center justify-between h-16">
          {/* Mobile Menu Button - Left */}
          <div className="md:hidden">
            <button 
              className="w-8 h-8 flex items-center justify-center"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-lg`}></i>
            </button>
          </div>

          {/* Logo - Center */}
          <div className="absolute left-1/2 transform -translate-x-1/2 md:relative md:left-auto md:transform-none text-xl font-bold tracking-[0.3em]">
            MILAN
          </div>
          
          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8">
            <a href="#" className="text-sm font-medium text-gray-900 hover:text-gray-600 transition-colors tracking-wider">
              HOME
            </a>
            <a href="#shop" className="text-sm font-medium text-gray-900 hover:text-gray-600 transition-colors tracking-wider">
              SHOP
            </a>
            <a href="#collections" className="text-sm font-medium text-gray-900 hover:text-gray-600 transition-colors tracking-wider">
              COLLECTIONS
            </a>
            <a href="#about" className="text-sm font-medium text-gray-900 hover:text-gray-600 transition-colors tracking-wider">
              ABOUT
            </a>
          </div>
          
          {/* Cart */}
          <div className="flex items-center">
            <button 
              className="w-8 h-8 flex items-center justify-center"
              onClick={() => window.open('https://shop.milan-online.jp/shops/milanec-base-shop/checkout/edit', '_blank')}
            >
              <i className="ri-shopping-bag-line text-lg"></i>
            </button>
          </div>
        </div>
        
        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-100">
            <div className="space-y-3">
              <a href="#" className="block text-sm font-medium text-gray-900 tracking-wider">HOME</a>
              <a href="#shop" className="block text-sm font-medium text-gray-900 tracking-wider">SHOP</a>
              <a href="#collections" className="block text-sm font-medium text-gray-900 tracking-wider">COLLECTIONS</a>
              <a href="#about" className="block text-sm font-medium text-gray-900 tracking-wider">ABOUT</a>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
